<div class="dialog-default p-4">
  <h4 class="blue-text">Mettre à jour mes coordonnées</h4>
  <hr>
  <div class="d-flex flex-row justify-content-start">
    <p class="blue-text">Vous :&nbsp;</p>
    <span>{{this.currentUser.firstName}} {{this.currentUser.lastName}}</span>
  </div>
  <label class="blue-text label-info">Numéro de téléphone</label>
  <div class="w-100 mb-2">
    <div class="row row-custom">
      <div class="col-4 col-sm-3 col-md-3 col-lg-5 col-xl-4 pl-0">
        <app-select [group]="phoneFormControl"
                    [items]="phoneRegionCodeForSelect"
                    fcName="phoneCode"></app-select>
      </div>

      <div class="col-8 col-sm-9 col-md-9 col-lg-7 col-xl-8 p-0">
        <app-input-text
          [control]="fPhone.phone"
          [group]="phoneFormControl"
          [required]=true
          errorMsg="Le numéro de téléphone est invalide."
          fcName="phone"
          placeholder="Nouveau numéro téléphone"></app-input-text>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      @if (isPhoneLoading) {
        <button class="btn btn-secondary"
                type="button" disabled>
          <mat-spinner [diameter]="30" class="loadingSpinner"></mat-spinner>
        </button>
      } @else {
      <button
        (click)="submitPhone()"
        [disabled]="!isPhoneCorrect"
        class="button-modify btn btn-primary">
        Mettre à jour mon téléphone
      </button>
      }
    </div>
  </div>

  <label class="blue-text label-info">Email</label>
  <div class="w-100">
    <app-input-text
      [control]="fEmail.email"
      [group]="emailFormControl"
      [required]=true
      errorMsg="L'adresse email est invalide."
      fcName="email"
      placeholder="Nouvel email"></app-input-text>
    <div class="d-flex justify-content-end">
      @if (isEmailLoading) {
        <button class="btn btn-secondary"
                type="button" disabled>
          <mat-spinner [diameter]="30" class="loadingSpinner"></mat-spinner>
        </button>
      } @else {
      <button
        (click)="submitMail()"
        [disabled]="!isEmailCorrect"
        class="button-modify btn btn-primary">
        Mettre à jour mon email
      </button>
      }
    </div>
  </div>
</div>

<div class="force-disconnect" [ngClass]="{'show': showForceDisconnect}">
  <div class="disconnect-card">
    <h1 class="blue-text">Changement d'email</h1>
    <p>Pour prendre en compte les modifications, veuillez-vous reconnecter.</p>
    <button class="btn btn-primary" (click)="disconnect()">Me déconnecter</button>
  </div>
</div>
